var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ className: styles["chevron-right-icon"] || "chevron-right-icon", xmlns: "http://www.w3.org/2000/svg", width: "12", height: "20", viewBox: "0 0 12 20" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M3.538 5.844a.5.5 0 1 1 .724-.688l3.8 4a.5.5 0 0 1 0 .688l-3.8 4a.5.5 0 1 1-.724-.688L7.01 9.5 3.538 5.844z" })
  );
});